// extracted by mini-css-extract-plugin
export default {"description":"changeStatus_description__8khhQ","content":"changeStatus_content__yklTC","contentItem":"changeStatus_contentItem__Ag0rV","status":"changeStatus_status__+raJC"};